export const LOADER_TYPES = {
  BAR: 'bar',
  SPINNER: 'spinner',
  SPINNER_IN_BUTTON: 'spinner-in-button',
  SUCCESS: 'success',
  TYPING: 'typing',
};
